<div class="authentication-container">
  <div *ngIf="isDesktop" class="left-item">
    <div><img alt="" class="" height="100px" src="assets/img/main-logo{{logo}}.svg"></div>
  </div>

  <div class="right-item">
    <router-outlet></router-outlet>
  </div>
  <ngx-spinner [fullScreen]="true" name="other-layout-spinner" size="default"
               type="line-spin-clockwise-fade"></ngx-spinner>
</div>
